import React, {FC, ReactNode} from 'react'

import cn from 'classnames/bind'

import MessageBlock from 'components/elements/MessageBlock'
import {IMessageBlockProps} from 'components/elements/MessageBlock/MessageBlock'

import s from './FormHeader.module.scss'
const cx = cn.bind(s)

interface IFormHeaderProps extends Partial<IMessageBlockProps> {
	className?: string
	title: string | ReactNode
	subTitle?: string | ReactNode
}

const FormHeader: FC<IFormHeaderProps> = ({
	className,
	title,
	subTitle,
	message,
	type = 'error',
}) => {
	const SubtitleEl = typeof subTitle === 'string' ? 'p' : 'div'
	return (
		<div className={cx('wrapper', className)}>
			<h2 className={cx('title')}>{title}</h2>
			{message && <MessageBlock type={type} message={message} />}

			{subTitle && <SubtitleEl className={cx('subTitle', 'fs-s')}>{subTitle}</SubtitleEl>}
		</div>
	)
}

FormHeader.displayName = 'FormHeader'

export default FormHeader
